function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Drawer, DrawerContent, DrawerOverlay, HStack, Icon, IconButton, useDisclosure } from '@chakra-ui/react';
import React from 'react';
import Logo from './icons/logos/Nightbot';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UserMenuAvatarButton } from './UserMenuAvatarButton';
import SideBar from './SideBar';
export default function DashboardNavbar(_param) {
    var topNavItems = _param.topNavItems, bottomNavItems = _param.bottomNavItems, props = _object_without_properties(_param, [
        "topNavItems",
        "bottomNavItems"
    ]);
    var intl = useIntl();
    var sidebarDrawer = useDisclosure();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(HStack, _object_spread_props(_object_spread({
                backgroundColor: "backgroundSecondary",
                borderBottomWidth: 1,
                borderColor: "borderTertiary",
                padding: 4,
                justifyContent: "space-between",
                alignItems: "center"
            }, props), {
                children: [
                    /*#__PURE__*/ _jsx(IconButton, {
                        icon: /*#__PURE__*/ _jsx(Icon, {
                            as: FontAwesomeIcon,
                            icon: faBars
                        }),
                        "aria-label": intl.formatMessage({
                            id: "kh4wt0",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Toggle Sidebar"
                                }
                            ]
                        }),
                        onClick: sidebarDrawer.onOpen
                    }),
                    /*#__PURE__*/ _jsx(Logo, {
                        boxSize: 8
                    }),
                    /*#__PURE__*/ _jsx(UserMenuAvatarButton, {})
                ]
            })),
            /*#__PURE__*/ _jsxs(Drawer, {
                placement: "left",
                isOpen: sidebarDrawer.isOpen,
                onClose: sidebarDrawer.onClose,
                children: [
                    /*#__PURE__*/ _jsx(DrawerOverlay, {}),
                    /*#__PURE__*/ _jsx(DrawerContent, {
                        children: /*#__PURE__*/ _jsx(SideBar, {
                            height: "100%",
                            topNavItems: topNavItems,
                            bottomNavItems: bottomNavItems,
                            onClose: sidebarDrawer.onClose
                        })
                    })
                ]
            })
        ]
    });
}
